export function formatMoney(value: number | string | null | undefined) {
  const amount = Number(value || 0);
  return new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    maximumFractionDigits: 0
  }).format(amount);
}

export function formatDate(value: string | Date | null | undefined) {
  if (!value) {
    return "Не указано";
  }

  return new Intl.DateTimeFormat("ru-RU").format(new Date(value));
}
